<div class="media-asset pdf-viewer w-full h-full flex relative flex-col">
  <div class="media-asset-visualizer pdf-viewer">
    <pdf-viewer
      *ngIf="mainURL$"
      [src]="(mainURL$ | async) || ''"
      [render-text]="true"
      [original-size]="false"
      [show-all]="true"
      [autoresize]="true"
      [zoom]="zoom"
      [(page)]="page"
      (after-load-complete)="afterPdfLoadComplete($event)"
      class="w-full h-full"
    >
    </pdf-viewer>
  </div>

  <div class="media-asset-toolbar">
    <ul class="media-asset-toolbar-list media-asset-toolbar-area grid-area-center pager-single">
      <li class="media-asset-toolbar-item grid-area-start">
        <button mat-icon-button (click)="previousPage()" [disabled]="page === 1">
          <mat-icon>navigate_before</mat-icon>
        </button>
      </li>
      <li class="media-asset-toolbar-item grid-area-center">
        <span class="whitespace-nowrap">{{ page }} / {{ totalPdfPages }}</span>
      </li>
      <li class="media-asset-toolbar-item grid-area-end">
        <button mat-icon-button (click)="nextPage()" [disabled]="totalPdfPages === 1 || page === totalPdfPages">
          <mat-icon>navigate_next</mat-icon>
        </button>
      </li>
    </ul>
  </div>
</div>
